/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who_OverlineInputs */

const en_dr_who_overline = /** @type {(inputs: Dr_Who_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who it's for`)
};

const id_dr_who_overline = /** @type {(inputs: Dr_Who_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk siapa`)
};

/**
* | output |
* | --- |
* | "Who it's for" |
*
* @param {Dr_Who_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who_overline = /** @type {((inputs?: Dr_Who_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who_overline(inputs)
	return en_dr_who_overline(inputs)
});